<template>
    <div>
        <div v-if="show" >
            <el-card class="box-card" @click.native="selectChart(1)">
                <div  class="text item">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i>
                    收支利潤表(保險公司層面)
                </div>
            </el-card>
            <el-card class="box-card " @click.native="selectChart(2)">
                <div  class="text item">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i>
                    年度收支表(保險公司層面)
                </div>
            </el-card>
            <el-card class="box-card " @click.native="selectChart(3)">
                <div  class="text item">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i>
                    收支利潤表(合作伙伴層面)
                </div>
            </el-card>
            <el-card class="box-card " @click.native="selectChart(4)">
                <div  class="text item">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i>
                    年度收支表(合作伙伴層面)
                </div>
            </el-card>
            <el-card class="box-card " @click.native="selectChart(5)">
                <div  class="text item">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i>
                    個別合作伙伴收支利潤表
                </div>
            </el-card>
        </div>
        <div style="clear: both;">

        </div>
        <div >
            <div v-if="!show">
                <el-button type="primary" @click="goBack()">返回</el-button></div>
            <div id="myChart" :style="{width: '800x', height: '700px'}" ></div>
        </div>
        <el-dialog title="选择月份" :visible.sync="commCaluView" width="380px" top="10vh"  >
            <div class="block">
                <span class="demonstration" >開始月份</span>
                <el-date-picker
                        size="small "
                        v-model="dateCode"
                        type="month"
                        placeholder="請選擇開始月份"
                        value-format="yyyy-MM"
                >
                </el-date-picker>
            </div>
            <div class="block">
                <span class="demonstration">結束月份</span>
                <el-date-picker
                        size="small "
                        v-model="endDateCode"
                        type="month"
                        placeholder="請選擇結束月份"
                        value-format="yyyy-MM"
                >
                </el-date-picker>
            </div>
            <div v-if="this.k==5" class="block">
                <span class="demonstration">选择员工</span>
                <el-select size="small "
                           v-model="staffUuid"
                           filterable
                           reserve-keyword
                           placeholder="" clearable
                           style="width:220px" default-first-option
                >
                    <el-option
                            v-for="staff in staffOption"
                            :key="staff.id"
                            :label="staff.nameChi"
                            :value="staff.uuid">
                    </el-option>
                </el-select>
            </div>
            <div v-if="this.k==3||this.k==5" class="block">
                <span class="demonstration">排序方式</span>
                <el-select size="small "
                           v-model="type"
                           filterable
                           reserve-keyword
                           placeholder="" clearable
                           style="width:220px" default-first-option
                >
                    <el-option
                            v-for="type in typeOption"
                            :key="type.id"
                            :label="type.name"
                            :value="type.id">
                    </el-option>
                </el-select>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="getChart" :loading="commCaluLoading">确定</el-button>
                <el-button size="small" @click="commCaluView = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="選擇年份" :visible.sync="commCaluView2" width="400px" top="10vh"  >
            <div class="block">
                <span class="demonstration" > 年   份 </span>&nbsp;
                <el-date-picker
                        size="small "
                        v-model="year"
                        type="year"
                        placeholder="請選擇年份"
                        value-format="yyyy"
                >
                </el-date-picker>
            </div>
            <div v-if="this.k==4" class="block">
                <span class="demonstration" style="margin-right:-2px">排序方式</span>&nbsp;
                <el-select
                        size="small"
                           v-model="type"
                           filterable
                           reserve-keyword
                           placeholder="" clearable
                           style="width:220px" default-first-option
                >
                    <el-option
                            size="small"
                            v-for="type in typeOption"
                            :key="type.id"
                            :label="type.name"
                            :value="type.id">
                    </el-option>
                </el-select>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="getChartYear" :loading="commCaluLoading">确定</el-button>
                <el-button size="small" @click="commCaluView2 = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

    import {queryReportUserByStaff,queryPolicyStaffByStaffType,queryCommissionReceived,queryCommissionReceivedYearly,queryCommissionReceivedUser,queryReceivedUserYearly} from '../api/api'
    export default {
        name: 'hello',
        data () {
            return {
                type:'',
                typeOption:[{name:'收入',id:'1'},{name:'支出',id:'2'},{name:'利润',id:'3'}],
                k:0,
                year:'',
                commCaluLoading:false,
                commCaluView:false,
                msg: 'Welcome to Your Vue.js App',
                dataMap:{},
                endDateCode:'',
                show:true,
                dateCode:'',
                staffUuid:'',
                dataList:{name:[],income:[],expenditure:[],profit:[],title:''},
                dataList2:{name:[],income:{},expenditure:{},profit:[],title:''},
                commCaluView2:false,
                staffOption:[],
                reportList:{name:[],income:[],expenditure:[],profit:[],title:''}
            }
        },
        methods:{
            drawLine5(){
                var myChart = this.$echarts.init(document.getElementById('myChart'))
                var emphasisStyle = {
                    itemStyle: {
                        barBorderWidth: 1,
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowColor: 'rgba(0,0,0,0.5)'
                    }
                };

              var  option = {
                    backgroundColor: '#eee',
                    legend: {
                        data: ['收入', '支出', '利润'],
                        left: 10,
                        top:50
                    },
                    brush: {
                        toolbox: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
                        xAxisIndex: 0
                    },
                    toolbox: {
                        feature: {
                            magicType: {
                                type: ['stack', 'tiled']
                            },
                            dataView: {}
                        }
                    },
                  title : {
                      show:true,//显示策略，默认值true,可选为：true（显示） | false（隐藏）
                      text:this.reportList.title,//主标题文本，'\n'指定换行
                      x:'center',//水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
                      y:'20px',//垂直安放位置，默认为top，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
                      textAlign: null,//水平对齐方式，默认根据x设置自动调整，可选为： left' | 'right' | 'center
                      backgroundColor: 'rgba(0,0,0,0)',//标题背景颜色，默认'rgba(0,0,0,0)'透明
                      borderColor: '#ccc',//标题边框颜色,默认'#ccc'
                      borderWidth: 0,//标题边框线宽，单位px，默认为0（无边框）
                      padding: 10,//标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距
                      itemGap: 20,//主副标题纵向间隔，单位px，默认为10
                   },
                    tooltip: {},
                    xAxis: {
                        data: this.reportList.name,
                        name: 'X Axis',
                        axisLine: {onZero: true},
                        splitLine: {show: false},
                        splitArea: {show: false}
                    },
                    yAxis: {
                        inverse: true,
                        splitArea: {show: false}
                    },
                    grid: {
                        left:180,
                        top:100
                    },
                    visualMap: {
                        type: 'continuous',
                        dimension: 1,
                        text: ['High', 'Low'],
                        inverse: true,
                        itemHeight: 200,
                        calculable: true,
                        top: 100,
                        left: 10,
                        inRange: {
                            colorLightness: [0.4, 0.8]
                        },
                        outOfRange: {
                            color: '#bbb'
                        },
                        controller: {
                            inRange: {
                                color: '#2f4554'
                            }
                        }
                    },
                    series: [
                        {
                            name: '收入',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: this.reportList.income
                        },
                        {
                            name: '支出',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: this.reportList.expenditure
                        },
                        {
                            name: '利润',
                            type: 'bar',
                            stack: 'two',
                            emphasis: emphasisStyle,
                            data: this.reportList.profit
                        },
                    ]
                };
                myChart.setOption(option)

            },
            querySetSalaryOption(){
                return queryPolicyStaffByStaffType('1,2,3').then(res=>{
                    if(res.errcode==200){
                        this.staffOption=res.data;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            getReportPic(val){
                this.dataList.name=val[0].reverse()
                //收入
                this.dataList.income=val[1].reverse()
                //支出
                this.dataList.expenditure=val[2].reverse()
                //利润
                this.dataList.profit=val[3].reverse()
                this.show=false
                this.commCaluView=false
                this.$echarts.init(document.getElementById('myChart')).clear()
                this.drawLine2()
            },
            getChart(){
                if(this.dateCode==null||this.dateCode==''){
                    this.$message.error('请选择开始日期');
                    return
                }else {
                    var dateCode=this.dateCode.split('-')[0]+this.dateCode.split('-')[1]
                    if(this.endDateCode==null||this.endDateCode==''){
                        var endDateCode= dateCode
                    }else {
                        var endDateCode=this.endDateCode.split('-')[0]+this.endDateCode.split('-')[1]
                    }
                }
                let params={yearMonth:dateCode,endYearMonth:endDateCode}

                if(this.k==1){
                    return   queryCommissionReceived(params).then(res=>{
                        if(res.errcode==200){
                            this.dataList.title='收支利潤表(保險公司層面)'
                            this.getReportPic(res.data)
                        }else {
                            this.$message.error(res.errmsg);
                        }
                    })
                }else if(this.k==3){
                    if(this.type==''){
                        this.$message.error('請選擇排序方式');
                        return
                    }
                    params.type=this.type
                    return queryCommissionReceivedUser(params).then(res=>{
                        if(res.errcode==200){
                            this.dataList.title='收支利潤表(合作伙伴層面)'
                            this.getReportPic(res.data)
                        }else {
                            this.$message.error(res.errmsg);
                        }
                    })
                }else if(this.k==5){
                    if(this.staffUuid==''){
                        this.$message.error('請選擇員工');
                    }else {
                        if(this.type==''){
                            this.$message.error('請選擇排序方式');
                            return
                        }
                        params.staffUuid=this.staffUuid
                        params.type=this.type
                        queryReportUserByStaff(params).then(res=>{
                            if(res.errcode==200){
                               let name=this.staffOption.find(v=>v.uuid==this.staffUuid).nameChi
                                this.reportList.title=name
                                this.reportList.name=res.data[0]
                                //收入
                                this.reportList.income=res.data[1]
                                //支出
                                this.reportList.expenditure=res.data[2]
                                //利润
                                this.reportList.profit=res.data[3]
                                this.show=false
                                this.commCaluView=false
                                this.drawLine5()
                            }else {
                                this.$message.error(res.errmsg);
                            }
                        })
                    }
                }


            },
            getChartYear(){

                if(this.year==''||this.year==null){
                    this.$message.error('請選擇年份');
                }else {
                    if(this.year>new Date().getFullYear()){
                        this.$message.error('請選擇正確的年份');
                        return;
                    }
                    let params={year:this.year}
                    if(this.k==4){
                        if(this.type==''){
                            this.$message.error('請選擇排序方式');
                            return
                        }
                        params.type=this.type
                        queryReceivedUserYearly(params).then(res=>{
                            if(res.errcode==200){
                                this.dataList2.title=this.year+'年度收支表(合作伙伴層面)'
                                this.dataList2.name=res.data[0]
                                for(let a=0;a< this.dataList2.name.length;a++){
                                    if(a%2!=0){
                                        this.dataList2.name[a]='/\n'+this.dataList2.name[a]
                                    }
                                }
                                let k=0
                                for(let a=0;a<res.data[1].length;a++){
                                    if(a%2!=0){
                                        k++
                                        this.dataList2.income[k]=res.data[1][a]
                                        this.dataList2.expenditure[k]=res.data[2][a]
                                    }
                                }
                                this.show=false
                                this.$echarts.init(document.getElementById('myChart')).clear()
                                this.draw()
                                this.drawLine();

                                this.commCaluView2=false
                            }else {
                                this.$message.error(res.errmsg);
                            }
                        })
                    }else {
                        queryCommissionReceivedYearly(params).then(res=>{
                            if(res.errcode==200){
                                this.dataList2.title=this.year+'年度收支表(保險公司層面)'
                                this.dataList2.name=res.data[0]
                                for(let a=0;a< this.dataList2.name.length;a++){
                                    if(a%2!=0){
                                        this.dataList2.name[a]='/\n'+this.dataList2.name[a]
                                    }
                                }
                                let k=0
                                for(let a=0;a<res.data[1].length;a++){
                                    if(a%2!=0){
                                        k++
                                        this.dataList2.income[k]=res.data[1][a]
                                        this.dataList2.expenditure[k]=res.data[2][a]
                                    }
                                }
                                this.show=false
                                this.$echarts.init(document.getElementById('myChart')).clear()
                                this.draw()
                                this.drawLine();
                                this.commCaluView2=false
                            }else {
                                this.$message.error(res.errmsg);
                            }
                        })
                    }

                }
            },
            goBack(){
                this.$echarts.init(document.getElementById('myChart')).clear()
                this.show=true
            },
            selectChart(k){
                this.k=k
                this.type=''
                if(k==1||k==3||k==5){
                    this.endDateCode=''
                    this.dateCode=''
                    this.staffUuid=''
                    this.commCaluView=true
                }else if(k==2||k==4){
                    this.year=''
                    this.commCaluView2=true
                }
            },
            drawLine2(){
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                // 绘制图表
                myChart.setOption( {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        backgroundColor:'white',
                        title: {text:this.dataList.title,x:'center',y:'20px'},
                        legend: {
                            data: [ '支出', '收入','利润'],
                            top:50
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            top:79,
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: [
                            {
                                type: 'value'
                            }
                        ],
                        yAxis: [
                            {
                                type: 'category',
                                axisTick: {
                                    show: false
                                },
                                data: this.dataList.name
                            }
                        ],
                        series: [
                            {
                                name: '收入',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    show: false
                                },
                                data:this.dataList.income
                            },
                            {
                                name: '支出',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    show: false,
                                },
                                data: this.dataList.expenditure
                            },  {
                                name: '利润',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    show: false,
                                    position: 'left'
                                },
                                data: this.dataList.profit
                            }

                        ]
                    }
                );
            },
            formatMoney(number, decimals =2, decPoint = '.', thousandsSep = ','){
                number = (number + '').replace(/[^0-9+-Ee.]/g, '')
                let n = !isFinite(+number) ? 0 : +number
                let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
                let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
                let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
                let s = ''
                let toFixedFix = function (n, prec) {
                    let k = Math.pow(10, prec)
                    return '' + Math.ceil(n * k) / k
                }
                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
                let re = /(-?\d+)(\d{3})/
                while (re.test(s[0])) {
                    s[0] = s[0].replace(re, '$1' + sep + '$2')
                }
                if ((s[1] || '').length < prec) {
                    s[1] = s[1] || ''
                    s[1] += new Array(prec - s[1].length + 1).join('0')
                }
                return s.join(dec)
            },
            draw(){
                this.dataMap={}
//支出
                this.dataMap.dataSI = this.dataFormatter(this.dataList2.income);
//收入
                this.dataMap.dataTI = this.dataFormatter(this.dataList2.expenditure);
            },
            dataFormatter(obj) {
                var pList = this.dataList2.name
                var temp;
                for (var year = 1; year <= 12; year++) {
                    var max = 0;
                    var sum = 0;
                    temp = obj[year];
                    for (var i = 0, l = temp.length; i < l; i++) {
                        max = Math.max(max, temp[i]);
                        sum += temp[i];
                        obj[year][i] = {
                            name: pList[i],
                            value: temp[i]
                        };
                    }
                    obj[year + 'max'] = Math.floor(max / 100) * 100;
                    obj[year + 'sum'] = sum;
                }

                return obj;
            },
            drawLine(){
                let that=this
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                // 绘制图表
                myChart.setOption( {
                    baseOption: {
                        timeline: {
                            axisType: 'category',
                            autoPlay: true,
                            data: [
                                '1月','2月','3月', '4月', '5月','6月','7月','8月','9月','10月','11月','12月'
                            ],
                            label: {

                            }
                        },
                        backgroundColor:'white',
                        title: {
                            text:this.dataList2.title,x:'center',y:'20px'
                        },
                        tooltip: {
                        },
                        legend: {
                            left: 'right',
                            data: [ '支出', '收入'],
                        },
                        calculable : true,
                        grid: {
                            top: 80,
                            bottom: 100,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow',
                                    label: {
                                        show: true,
                                        formatter: function (params) {
                                            return params.value.replace('\n', '');
                                        }
                                    }
                                }
                            }
                        },
                        xAxis: [
                            {
                                'type':'category',
                                'axisLabel':{'interval':0},
                                'data':this.dataList2.name,
                                splitLine: {show: false}
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                name: '（元）'
                            }
                        ],
                        series: [
                            {name: '支出', type: 'bar'},
                            {name: '收入', type: 'bar'},
                            {
                                name: '占比',
                                type: 'pie',
                                center: ['75%', '35%'],
                                radius: '28%',
                                z: 100,
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true,
                                            position: 'top',
                                            formatter:' {c} ({d}%)'
                                        }
                                    }
                                }
                            },
                        ],

                    },
                    options: [
                        {
                            title: {text: this.dataList2.title,y:'20px'},
                            series: [
                                {data: this.dataMap.dataSI['1'], itemStyle: {
                                        normal: {
                                            label: {
                                                show: true,
                                                position: 'top',
                                                formatter: function (params) {
                                                    return that.formatMoney(params.value)
                                                }
                                            }
                                        }
                                    }},
                                {data: this.dataMap.dataTI['1'],itemStyle: {
                                        normal: {
                                            label: {
                                                show: true,
                                                position: 'top',
                                                formatter: function (params) {
                                                    return that.formatMoney(params.value)
                                                }
                                            }
                                        }
                                    }},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['1sum']},
                                        {name: '收入', value: this.dataMap.dataTI['1sum']}
                                    ]}
                            ]
                        },
                        {
                            title: {text:this.dataList2.title,y:'20px'},
                            series: [
                                {data: this.dataMap.dataSI['2'], itemStyle: {
                                        normal: {
                                            label: {
                                                show: true,
                                                position: 'top',
                                                formatter: function (params) {
                                                    return that.formatMoney(params.value)
                                                }
                                            }
                                        }
                                    }},
                                {data: this.dataMap.dataTI['2'],itemStyle: {
                                        normal: {
                                            label: {
                                                show: true,
                                                position: 'top',
                                                formatter: function (params) {
                                                    return that.formatMoney(params.value)
                                                }
                                            }
                                        }
                                    }},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['2sum']},
                                        {name: '收入', value: this.dataMap.dataTI['2sum']}
                                    ]}
                            ]
                        },
                        {
                            title: {text: this.dataList2.title,y:'20px'},
                            series: [
                                {data: this.dataMap.dataSI['3'], itemStyle: {
                                        normal: {
                                            label: {
                                                show: true,
                                                position: 'top',
                                                formatter: function (params) {
                                                    return that.formatMoney(params.value)
                                                }
                                            }
                                        }
                                    }},
                                {data: this.dataMap.dataTI['3'],itemStyle: {
                                        normal: {
                                            label: {
                                                show: true,
                                                position: 'top',
                                                formatter: function (params) {
                                                    return that.formatMoney(params.value)
                                                }
                                            }
                                        }
                                    }},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['3sum']},
                                        {name: '收入', value: this.dataMap.dataTI['3sum']}
                                    ]}
                            ]
                        },
                        {
                            title: {text: this.dataList2.title,y:'20px'},
                            series: [
                                {data: this.dataMap.dataSI['4']},
                                {data: this.dataMap.dataTI['4']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['4sum']},
                                        {name: '收入', value: this.dataMap.dataTI['4sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['5']},
                                {data: this.dataMap.dataTI['5']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['5sum']},
                                        {name: '收入', value: this.dataMap.dataTI['5sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['6']},
                                {data: this.dataMap.dataTI['6']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['6sum']},
                                        {name: '收入', value: this.dataMap.dataTI['6sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['7']},
                                {data: this.dataMap.dataTI['7']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['7sum']},
                                        {name: '收入', value: this.dataMap.dataTI['7sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['8']},
                                {data: this.dataMap.dataTI['8']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['8sum']},
                                        {name: '收入', value: this.dataMap.dataTI['8sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['9']},
                                {data: this.dataMap.dataTI['9']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['9sum']},
                                        {name: '收入', value: this.dataMap.dataTI['9sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['10']},
                                {data: this.dataMap.dataTI['10']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['10sum']},
                                        {name: '收入', value: this.dataMap.dataTI['10sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['11']},
                                {data: this.dataMap.dataTI['11']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['11sum']},
                                        {name: '收入', value: this.dataMap.dataTI['11sum']}
                                    ]}
                            ]
                        },
                        {
                            title : {text: this.dataList2.title,y:'20px'},
                            series : [
                                {data: this.dataMap.dataSI['12']},
                                {data: this.dataMap.dataTI['12']},
                                {data: [
                                        {name: '支出', value: this.dataMap.dataSI['12sum']},
                                        {name: '收入', value: this.dataMap.dataTI['12sum']}
                                    ]}
                            ]
                        }
                    ]
                });
            }
        },
        mounted(){
            this.querySetSalaryOption()
        },

    }
</script>
<style scoped>
    .text {
        font-size: 18px;
    }

    .item {
        padding: 30px 0;
    }

    .box-card {
        width:350px;
        float: left;
        margin: 0px 20px 10px 0px;
        text-align: center;
    }
    .block{
        margin-top:10px;
    }
    .demonstration{
        margin-right:15px;
    }
</style>




// WEBPACK FOOTER //
// src/views/Echars.vue